import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserdataService } from 'src/app/services/userdata.service';
import { AdditionalFeaturesPopupComponent } from '../additional-features-popup/additional-features-popup.component';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-vumatel-network-events',
  templateUrl: './vumatel-network-events.component.html',
  styleUrls: ['./vumatel-network-events.component.scss', '../../enroll/components/packages/packages.component.scss']
})
export class VumatelNetworkEventsComponent implements OnInit {
  data: any
  future = false
  head = 'Open'
  @ViewChildren('statusText') statusTextElements!: QueryList<ElementRef>;
  @ViewChildren('Suburb') suburbTextElements!: QueryList<ElementRef>;

  overflowStatuses: boolean[] = []; 
  dataLoaded=false
  overflowStatuses1: boolean[]=[];
  showScrollToTopButton: boolean;
  constructor(
    private userdataservice: UserdataService,
    public dialog: MatDialog,
    private navigationservice:NavigationService
  ) { }

  ngOnInit(): void {
    this.getdata(1)
  }
  ngAfterViewChecked(): void {
    if (this.dataLoaded) {
      this.checkAllTextOverflow();  
      this.dataLoaded = false; 
    }
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const yOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.showScrollToTopButton = yOffset > 200; // Show button after scrolling down 200px
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  checkAllTextOverflow(): void {
    this.overflowStatuses = this.statusTextElements.map((element) => {
      const nativeElement = element.nativeElement;
      return nativeElement.scrollWidth > nativeElement.clientWidth;
    });
    this.overflowStatuses1 = this.suburbTextElements.map((element) => {
      const nativeElement = element.nativeElement;
      return nativeElement.scrollWidth > nativeElement.clientWidth;
    });
  }
  openDialog(text , type,index) {
    if ((type === 'status' && this.overflowStatuses[index]) || 
    (type === 'suburb' && this.overflowStatuses1[index])) {
      const dialogref = this.dialog.open(AdditionalFeaturesPopupComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: "30%",
        data: {
          text: text,
          title:'showtext'
        }
      });
}

  }

  getdata(value) {
    this.userdataservice.getVumatelEvents(value).subscribe((result) => {
      this.data = result;
      this.dataLoaded=true
      this.checkAllTextOverflow()
    })
  }

  toggleSwitch() {
    if (this.future) {
      this.head = 'Future'
      this.getdata(2)
    }
    else {
      this.head = 'Open'
      this.getdata(1)
    }
  }
view(data){
  this.navigationservice.gotoviewvumartalnetworkevents(data)
}
}
